export const WorkoutExitReason = {
  RestTooLong: 'rest_too_long',
  RestTooShort: 'rest_too_short',
  ExercisesTooEasy: 'exercises_too_easy',
  ExercisesTooHard: 'exercises_too_hard',
  Other: 'other',
} as const;

export type WorkoutExitReason = (typeof WorkoutExitReason)[keyof typeof WorkoutExitReason];

export const WORKOUT_EXIT_REASONS: WorkoutExitReason[] = [
  WorkoutExitReason.RestTooLong,
  WorkoutExitReason.RestTooShort,
  WorkoutExitReason.ExercisesTooEasy,
  WorkoutExitReason.ExercisesTooHard,
  WorkoutExitReason.Other,
];
